import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import styled from 'styled-components';
import Box from '../../Box';
export const RestoreButton = styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n"])));
export const RestoreButtonLabel = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  text-decoration: underline;\n  color: ", ";\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.colors.feedback.danger.normal;
});